class SingleExecutionHandler {
    constructor(sender, event, callback) {
        this._inExecution = false;

        sender.on(event, async (event) => {
            if (this._inExecution) {
                return;
            }

            this._inExecution = true;
            await callback(event);
            this._inExecution = false;
        });
    }
}
